import { type ExportTaskType } from '@webapp/modules/reports/entities/enums/ExportTaskTypeEnum'
import { type ReportExportTask } from '@webapp/modules/reports/entities/ReportExportTask'
import { useExportTaskListPresenter } from './useExportTaskListPresenter'
import { ExportTaskHistoryTable } from '../../views/ExportTaskHistoryTable'

export interface IExportTaskListPresenterProps {
  /** Derived from the referrer query param by the FS (BHV-035) */
  typeFilter: ExportTaskType[]
  /** FS-owned filter state (default last 3 months → tomorrow, BHV-035) */
  dateRange: { from: string; to: string }
  /** Opens the FS-owned delete confirmation modal (ADR-9, BHV-037) */
  onDeleteRequest: (task: ReportExportTask) => void
}

export const ExportTaskListPresenter = ({
  typeFilter,
  dateRange,
  onDeleteRequest,
}: IExportTaskListPresenterProps) => {
  const {
    data: { items, sortOptions },
    methods,
    states: { isFetching },
  } = useExportTaskListPresenter({ typeFilter, dateRange, onDeleteRequest })

  return (
    <ExportTaskHistoryTable
      items={items}
      isLoading={isFetching}
      sortOptions={sortOptions}
      onDeleteRequest={methods.onDeleteRequest}
      paginationId='REPORT_EXPORT_HISTORY'
    />
  )
}

ExportTaskListPresenter.displayName = 'ExportTaskListPresenter'
